import { FILTER_TYPES, PAGE_SIZE_FILTER } from 'constants/filterType';

export const ADMIN_SHELF_FILTER_OPTIONS = [
  {
    field: 'code__icontains',
    label: 'Shelf Code',
    type: FILTER_TYPES.TEXT,
  },
  {
    field: 'name__icontains',
    label: 'Shelf Name',
    type: FILTER_TYPES.TEXT,
  },
  {
    field: 'active',
    label: 'Active',
    type: FILTER_TYPES.SELECT,
    options: [
      { value: 'true', label: 'Active' },
      { value: 'false', label: 'Inactive' },
    ],
  },
  { ...PAGE_SIZE_FILTER },
];
